module.exports = __webpack_public_path__ + "static/img/图层12.f61cbdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层12.png
// module id = RsEe
// module chunks = 0